import React from 'react'
import { css } from 'aphrodite'
import { Container, Row, Col } from 'reactstrap'

import style from './style'

export const DashboardContainer = props => {
  const { component, ..._props } = props

  return (
    <Row tag='section' className={css(style.main.section)}>
      <Container>
        <Row>
          <Col xs='12'>
            <props.component {..._props} />
          </Col>
        </Row>
      </Container>
    </Row>
  )
}

export default DashboardContainer



// WEBPACK FOOTER //
// ./src/components/partials/DashboardContainer/index.js